import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseAccountApiUrl, baseAccountPublicApiUrl, baseNonExternalAccountApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';
import { setUFOInteractionErrorCheck } from 'util/ufoUtils';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  ufoName?: string,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseAccountApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    setUFOInteractionErrorCheck(ufoName);
    return Promise.reject(error);
  }
};

export const getFromHamsClientPublicAPI = async (
  remainingPath: string,
  state: State,
  ufoName: string,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseAccountPublicApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error: any) {
    setUFOInteractionErrorCheck(ufoName);
    if (error.response.status === 403 && error.response.data.errorKey === 'forbidden.error') {
      return 'Access denied';
    }
    return Promise.reject(error);
  }
};

export const getFromHamsClientNonExternalAccountAPI = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  ufoName?: string,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseNonExternalAccountApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    setUFOInteractionErrorCheck(ufoName);
    return Promise.reject(error);
  }
};
